export default __webpack_public_path__ + "static/media/B246.39a61c80.png";